import React from "react";

import { Textarea } from "~/components/ui/textarea";
import { FACTURA_OBSERVATIONS_MAX_LENGTH } from "~/constants/facturas";
import { useProfileStore } from "~/store/profileStore";

interface CommentsSectionProps {
  comments: string;
  setComments: (comments: string) => void;
  internalNotes?: string;
  setInternalNotes?: (notes: string) => void;
  facturaObservations?: string;
  setFacturaObservations?: (observations: string) => void;
}

const CommentsSection: React.FC<CommentsSectionProps> = ({
  comments,
  setComments,
  internalNotes = "",
  setInternalNotes = () => {},
  facturaObservations = "",
  setFacturaObservations = () => {},
}) => {
  const { role } = useProfileStore();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="mb-3 text-base font-medium sm:text-lg">
          Comentarios para el cliente
        </h3>
        <Textarea
          placeholder="Instrucciones de entrega u otra información que será visible para el cliente"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          className="min-h-[80px]"
          rows={3}
        />
        <p className="mt-1 text-xs text-gray-500">
          Esta información puede ser compartida con el cliente.
        </p>
      </div>

      <div>
        <h3 className="mb-3 flex items-center text-base font-medium sm:text-lg">
          <span className="relative">
            Notas internas
            <span className="absolute -right-2 -top-1 h-2 w-2 rounded-full bg-amber-500"></span>
          </span>
        </h3>
        <Textarea
          placeholder="Instrucciones o información para uso interno (no visible para el cliente)"
          value={internalNotes}
          onChange={(e) => setInternalNotes(e.target.value)}
          className="min-h-[80px] border-amber-200 focus-visible:ring-amber-500"
          rows={3}
        />
        <p className="mt-1 text-xs text-amber-600">
          Esta información es solo para uso interno y no será compartida con el
          cliente.
        </p>
      </div>

      <div>
        <h3 className="mb-3 flex items-center text-base font-medium sm:text-lg">
          <span className="relative">
            Observaciones para factura
            <span className="absolute -right-2 -top-1 h-2 w-2 rounded-full bg-blue-500"></span>
          </span>
        </h3>
        <Textarea
          placeholder="Observaciones o detalles que aparecerán en la factura"
          value={facturaObservations}
          onChange={(e) => setFacturaObservations(e.target.value)}
          className="min-h-[80px] border-blue-200 focus-visible:ring-blue-500"
          rows={3}
          maxLength={FACTURA_OBSERVATIONS_MAX_LENGTH}
        />
        <div className="mt-1 flex items-center justify-between gap-2">
          <p className="text-xs text-blue-600">
            Esta información se utilizará para la generación de facturas.
          </p>
          <span
            className={`shrink-0 text-xs ${
              facturaObservations.length >= FACTURA_OBSERVATIONS_MAX_LENGTH
                ? "text-red-600"
                : facturaObservations.length >=
                    FACTURA_OBSERVATIONS_MAX_LENGTH * 0.9
                  ? "text-amber-600"
                  : "text-gray-500"
            }`}
          >
            {facturaObservations.length} / {FACTURA_OBSERVATIONS_MAX_LENGTH}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CommentsSection;
